exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".message-alert{border-radius:5px;padding:10px}.message-alert.bg-info{background-color:#d8ddec!important;border-color:#c8cfe4;color:#1e2c53}.message-alert.bg-success{color:#1d643b;background-color:#d7f3e3!important;border-color:#c7eed8}", ""]);

// exports
